<template>
  <div class="app-container" >
    <div style="background-color: rgb(255, 255, 255); position: relative; height: calc(100% + 0px); width: 100%; padding: 20px;">
    
    
           <img  style="width: calc(100% - 20px); height: 100px; position: absolute; margin: unset; " src="@/assets/images/Ai.png" >

   
      <!-- <el-divider></el-divider> -->

          <el-card  ref="myCardall" class="box-card" style="
    margin-top: 110px; height: 100%;
" >
  <div slot="header" class="clearfix">
    <div class="flex-row justify-between">
    <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">&nbsp;&nbsp;</div>
    <span style="padding-left: 6px;  position: absolute;font-weight: 650;">XXXXX标书名称</span>
    <span style="padding-left: 180px;position: absolute;font-weight: 300;font-size: 14px;height: 30px;">评分自检 ：80分  风险预警 ：0项</span>
    </div>
  </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="评分自测" name="first">
  <!-- <pfzcyzc :tree="tree"></pfzcyzc> -->
  <pfzcwzc :tree="tree"></pfzcwzc>

    </el-tab-pane>
    <el-tab-pane label="风险评估" name="second">
<!-- <fxpgyzc :tree="tree"></fxpgyzc> -->

<fxpgwzc></fxpgwzc>
 
    </el-tab-pane>
  
</el-tabs>



</el-card>


  </div>
  </div>
</template>

<script>


// 评分自测(已自测)
import pfzcyzc from './selfassessment/index2.vue'
// 评分自测(未自测)
import pfzcwzc from './selfassessment/index.vue'

// 风险评估(已自测)
import fxpgyzc from './riskassessment/index2.vue'
// 风险评估(未自测)
import fxpgwzc from './riskassessment/index.vue'

import { listSelfassessment, getSelfassessment, delSelfassessment, addSelfassessment, updateSelfassessment } from "@/api/intelligentinspection/selfassessment";

export default {
  name: "Selfassessment",
    components: { pfzcyzc ,fxpgyzc,pfzcwzc,fxpgwzc},

  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 标书评分自测表格数据
      selfassessmentList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: null,
        tenantId: null,
        bidCode: null,
        scoreType: null,
        scoreItem: null,
        itemContent: null,
        itemScore: null,
        selfAssessmentScore: null,
        conclusion: null,
        contentPosition: null,
        version: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      },

  activeName: 'first',

      loading:false,
                   // three
 showTreeMenu: false,
            contextNode: {},
            tree: [
                {
                    id: 1,
                    name: '一级目录',
                    children: [
                        {
                            id: 5,
                            name: '二级目录',
                            children: [
                                {
                                    id: 17,
                                    name: '三级目录',
                                    children: []
                                },
                                {
                                    id: 18,
                                    name: '三级目录',
                                    children: []
                                }
                            ]
                        },
                        {
                            id: 6,
                            name: '二级目录',
                            children: [
                                {
                                    id: 19,
                                    name: '三级目录',
                                    children: []
                                },
                                {
                                    id: 20,
                                    name: '三级目录',
                                    children: []
                                },
                                {
                                    id: 21,
                                    name: '三级目录',
                                    children: [
                                        {
                                            id: 22,
                                            name: '四级目录',
                                            children: []
                                        },
                                        {
                                            id: 23,
                                            name: '四级目录',
                                            children: []
                                        },
                                        {
                                            id: 24,
                                            name: '四级目录',
                                            children: []
                                        },
                                        {
                                            id: 25,
                                            name: '四级目录',
                                            children: []
                                        },
                                        {
                                            id: 26,
                                            name: '四级目录',
                                            children: []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: 7,
                            name: '二级目录',
                            children: []
                        },
                        {
                            id: 8,
                            name: '二级目录',
                            children: []
                        },
                        {
                            id: 10,
                            name: '二级目录',
                            children: []
                        }
                    ]
                },
                {
                    id: 2,
                    name: '一级目录',
                    children: [
                        {
                            id: 11,
                            name: '二级目录',
                            children: []
                        },
                        {
                            id: 12,
                            name: '二级目录',
                            children: []
                        }
                    ]
                },
                {
                    id: 3,
                    name: '一级目录',
                    children: [
                        {
                            id: 13,
                            name: '二级目录',
                            children: []
                        },
                        {
                            id: 14,
                            name: '二级目录',
                            children: []
                        },
                        {
                            id: 15,
                            name: '二级目录',
                            children: []
                        },
                        {
                            id: 16,
                            name: '二级目录',
                            children: []
                        }
                    ]
                }
            ]
       
      // end three
    };
  },
  created() {
    // this.getList();
  },
    mounted() {
    this.$nextTick(() => {
      // this.initChart()
    })
  },
  beforeDestroy() {
    // if (!this.chart) {
    //   return
    // }
    // this.chart.dispose()
    // this.chart = null
  },
  methods: {
    /** 查询标书评分自测列表 */
    getList() {
      this.loading = true;
      listSelfassessment(this.queryParams).then(response => {
        this.selfassessmentList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        pid: null,
        tenantId: null,
        bidCode: null,
        scoreType: null,
        scoreItem: null,
        itemContent: null,
        itemScore: null,
        selfAssessmentScore: null,
        conclusion: null,
        contentPosition: null,
        version: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加标书评分自测";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getSelfassessment(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改标书评分自测";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updateSelfassessment(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addSelfassessment(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除标书评分自测编号为"' + pids + '"的数据项？').then(function() {
        return delSelfassessment(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('intelligentinspection/selfassessment/export', {
        ...this.queryParams
      }, `selfassessment_${new Date().getTime()}.xlsx`)
    },

    tabpush(){

      this.$router.push({ path: '/biddingdocument/bid/index' });  
    },
 
  }
};
</script>
<style src="../index1/common.css" />
<style src="../index1/index.css" />

<style scoped>

 ::v-deep  .el-tree {
    /* position: relative;
    cursor: default;
    background: #FFFFFF;
    color: #606266; */
    height: 250px;
    overflow: auto;
}
</style>